import React from "react";
import { ChevronLeft } from "lucide-react";

export const ProgressBar = ({ value }) => (
  <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
    <div
      className="h-full bg-[#FF5E1A] transition-all duration-500 ease-out"
      style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      data-testid="progress-bar-fill"
    />
  </div>
);

export const LanguageToggle = ({ lang, setLang }) => (
  <div
    className="inline-flex items-center bg-gray-100 rounded-full p-1 text-sm font-medium"
    data-testid="language-toggle"
  >
    <button
      type="button"
      onClick={() => setLang("english")}
      data-testid="lang-english-btn"
      className={`px-3 py-1.5 rounded-full transition-all ${
        lang === "english"
          ? "bg-white text-[#0F172A] shadow-sm"
          : "text-[#64748B]"
      }`}
    >
      English
    </button>
    <button
      type="button"
      onClick={() => setLang("hinglish")}
      data-testid="lang-hinglish-btn"
      className={`px-3 py-1.5 rounded-full transition-all ${
        lang === "hinglish"
          ? "bg-white text-[#0F172A] shadow-sm"
          : "text-[#64748B]"
      }`}
    >
      Hinglish
    </button>
  </div>
);

export const TopBar = ({
  showBack,
  onBack,
  stepLabel,
  progress,
  lang,
  setLang,
}) => (
  <div className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/40">
    <div className="max-w-xl mx-auto px-5 pt-4 pb-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          {showBack ? (
            <button
              type="button"
              onClick={onBack}
              data-testid="back-btn"
              className="p-2 -ml-2 rounded-full text-gray-500 hover:text-[#0F172A] hover:bg-gray-100 transition-colors"
              aria-label="Back"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
          ) : (
            <div className="w-9 h-9 rounded-xl bg-[#FF5E1A] flex items-center justify-center text-white font-bold font-heading text-base">
              C
            </div>
          )}
          <div className="flex flex-col leading-tight min-w-0">
            <span className="text-[11px] uppercase tracking-[0.12em] text-gray-400 font-semibold">
              ChannelPartner.Network
            </span>
            {stepLabel && (
              <span
                className="text-sm font-semibold text-[#0F172A] truncate"
                data-testid="step-label"
              >
                {stepLabel}
              </span>
            )}
          </div>
        </div>
        <LanguageToggle lang={lang} setLang={setLang} />
      </div>
      {progress !== null && progress !== undefined && (
        <div className="mt-3">
          <ProgressBar value={progress} />
        </div>
      )}
    </div>
  </div>
);

export const Shell = ({ children }) => (
  <div className="min-h-[100dvh]">
    <div className="max-w-xl mx-auto px-5 pt-28 pb-10 flex flex-col">
      <div className="glass-strong rounded-3xl p-5 md:p-8">
        {children}
      </div>
    </div>
  </div>
);
